<template>
  <tbody v-if="events && events.length > 0 && isVisible">
  <template v-for="event in events" v-if="isVisible">
    <tr>
      <td class="resource-name resource-column operation column-left">
        <b-card class="plan-title sub-card mb-0">
          <div class="d-flex align-items-center">
            <div v-if="hasSubEvents && event.startEvent !== event.endEvent && event.hasOwnProperty('objectLinked') && event.objectLinked.type === 'OperationConstruction'" class="add-event-button"
                 @click="$emit('add-sub-event', event)">
              +
            </div>
            <div v-if="hasSubEvents && event.startEvent === event.endEvent" class="add-event-button-invisible">+</div>
            <b-card-text
              :style="{ marginLeft: '0.75em', minWidth: '105px', marginTop: '10px', marginBottom: '10px' }"
              class="d-flex align-items-center justify-content-between w-100 ">
              <div class="d-flex align-items-center menu-text">
                <div :class="{'cursor-pointer':event.startEvent}" @click="$emit('scroll-to-event',event)">
                  {{ $t(event.event_type.text) }}
                </div>
                <div v-if="event.hasOwnProperty('objectLinked') && event.objectLinked.type === 'OperationConstruction'" class="ml-2">
                  <span id="color_front" @click="openColorPicker(event.id)" class="cursor-pointer" :style="{backgroundColor : event.color}"></span>
                  <b-form-input
                    type="color"
                    v-model="event.color"
                    @change="$emit('update-color',event)"
                    :ref="'colorPicker' + event.id"
                  />
                </div>
              </div>
            </b-card-text>
            <div v-if="hasSubEvents && event.subPlages && event.subPlages.length > 0"
                 class="ml-auto d-flex align-items-center">
              <div :class="{ rotated: areSubEventsVisible(event.id) }" class="toggle-sub-events-button"
                   @click="toggleSubEvents(event.id)">
                <b-icon-chevron-right aria-hidden="true" class="cursor-pointer" variant="dark"/>
              </div>
            </div>
          </div>
        </b-card>
      </td>
      <td
        v-for="period in periods"
        :key="getPeriodKey(period)"
        :class="{ 'current-month': isCurrentPeriod(period) }"
        :style="{ '--current-day-percentage': currentProgressPercentage() + '%' }"
        class="month"
      >
        <div v-if="event.startEvent && isEventInPeriod(event, period)" :id="'event' + event.id" class="event">
          <Evenement :evenement-type="evenementType" :event="event" :period="period" :scale="scale" text-color="white"/>
        </div>

        <!-- Une seule div event pour tous les nestedEvents orphelins de cette cellule -->
        <div v-if="getNestedEventsForPeriod(event, period).length > 0" class="event">
          <div v-for="nestedEvent in getNestedEventsForPeriod(event, period)"
               :key="'nested-' + nestedEvent.id"
               :style="{
           backgroundColor: '#9E0430',
           left: calculateNestedPosition(nestedEvent, period) + 'px',
           position: 'absolute',
           width: '13px',
           height: '13px',
           borderRadius: '50%',
           border: '1px solid black',
           transform: 'translateY(80%)',
           zIndex: 1
         }"
               class="disk nested-date-disk"
               @mouseenter="showTooltip(nestedEvent.id, $event, nestedEvent.startEvent, nestedEvent.endEvent, nestedEvent, true)"
               @mouseleave="hideTooltip()">
            <div v-if="nestedEvent.id === hoveredEventId" :style="tooltipStyle"
                 class="tooltip-custom-nested">
              <div class="tooltip-title">
                {{ nestedEvent.event_type ? $t(nestedEvent.event_type.text || nestedEvent.event_type) : 'Nested Event' }}
              </div>
              <div class="tooltip-date">{{ formatDate(nestedEvent.startEvent) }}</div>
            </div>
          </div>
        </div>
      </td>
    </tr>

    <tr v-for="subEvent in event.subPlages"
        v-if="hasSubEvents && event.subPlages && event.subPlages.length > 0 && areSubEventsVisible(event.id)"
        :key="subEvent.id">
      <td class="resource-name resource-column operation column-left">
        <b-card class="plan-title sub-card mb-0">
          <div class="d-flex align-items-center">
            <b-card-text
              :style="{ 'margin-left': '3em', 'min-width': '105px', 'margin-top': '10px', 'margin-bottom': '10px' }"
              class="d-flex align-items-center justify-content-between w-100">
              <div class="d-flex align-items-center menu-text" :class="{'cursor-pointer':subEvent.startEvent}" @click="$emit('scroll-to-event',subEvent)">{{ $t(subEvent.name) }}</div>
            </b-card-text>
            <b-icon-pencil-square
              aria-hidden="true"
              class="cursor-pointer" variant="dark"
              @click="$emit('edit-sub-event', subEvent, event)"/>
            <b-icon-trash-fill :style="{ 'margin-left': '8px' }" aria-hidden="true" class="cursor-pointer"
                               variant="dark" @click="$emit('delete-sub-event', event, subEvent.id)"/>
          </div>
        </b-card>
      </td>
      <td
        v-for="period in periods"
        :key="getPeriodKey(period)"
        :class="{ 'current-month': isCurrentPeriod(period) }"
        :style="{ '--current-day-percentage': currentProgressPercentage() + '%' }"
        class="month"
      >
        <div v-if="isEventInPeriod(subEvent, period)" :id="'subEvent' + subEvent.id" class="event sub-event-item">
          <Evenement :evenement-type="evenementType" :event="subEvent" :period="period" :scale="scale"
                     text-color="white"/>
        </div>
      </td>
    </tr>
  </template>
  </tbody>

</template>

<script>
import Evenement from './Evenement';

export default {
  components: {
    Evenement,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
    hasSubEvents: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: String,
      default: "month",
    },
  },

  data() {
    return {
      hoveredEventId: null,
      tooltipStyle: {
        position: 'absolute',
        left: '50%',
        bottom: '200%',
        '--color-event': '#9E0430'
      }
    }
  },

  computed: {
    periods() {
      return this.$parent.periods;
    },
    evenementType() {
      return this.$parent.evenementType;
    },
  },
  methods: {

    showTooltip(eventId, mouseEvent, startEvent, endEvent, event, isNested = false) {
      this.hoveredEventId = eventId;
      this.tooltipStyle.bottom = isNested ? '200%' : '140%';
      this.tooltipStyle["--color-event"] = isNested ? "#9E0430" : event.color;
    },

    hideTooltip() {
      this.hoveredEventId = null;
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString('fr-FR');
    },

    getPeriodKey(period) {
      return this.$parent.getPeriodKey(period);
    },
    isCurrentPeriod(period) {
      return this.$parent.isCurrentPeriod(period);
    },
    isPastPeriod(period) {
      return this.$parent.isPastPeriod(period);
    },
    isEventInPeriod(event, period) {
      if (this.scale === 'month') {
        return this.$parent.isEventThisMonth(period, event);
      } else if (this.scale === 'week') {
        return this.$parent.isEventThisWeek(period, event);
      } else if (this.scale === 'day') {
        return this.$parent.isEventThisDay(period, event);
      }
      return false;
    },
    areSubEventsVisible(eventId) {
      return this.$parent.areSubEventsVisible(eventId);
    },
    currentProgressPercentage() {
      return this.$parent.currentProgressPercentage();
    },

    toggleSubEvents(eventId) {
      this.$parent.toggleSubEvents(eventId)
    },

    openColorPicker(eventId) {
      if (this.$refs['colorPicker' + eventId]) {
        this.$refs['colorPicker' + eventId][0].$el.click();
      } else {
        console.warn(`Color picker with id colorPicker${eventId} not found.`);
      }
    },

    getNestedEventsForPeriod(event, period) {
      if (!event.nestedEvents || event.nestedEvents.length === 0) {
        return [];
      }

      return event.nestedEvents.filter(nestedEvent => {
        if (!nestedEvent.startEvent) return false;

        const nestedDate = new Date(nestedEvent.startEvent);
        const eventStartDate = new Date(event.startEvent);

        // Afficher le nestedEvent dans cette période s'il correspond ET s'il n'est pas dans la même période que son parent
        if (this.scale === 'month') {
          return nestedDate.getMonth() === period.getMonth() &&
            nestedDate.getFullYear() === period.getFullYear() &&
            !(eventStartDate.getMonth() === period.getMonth() && eventStartDate.getFullYear() === period.getFullYear());
        } else if (this.scale === 'week') {
          return this.$parent.isEventThisWeek(period, {startEvent: nestedEvent.startEvent}) &&
            !this.$parent.isEventThisWeek(period, event);
        } else if (this.scale === 'day') {
          return this.$parent.isEventThisDay(period, {startEvent: nestedEvent.startEvent}) &&
            !this.$parent.isEventThisDay(period, event);
        }
        return false;
      });
    },

    calculateNestedPosition(nestedEvent, period) {
      const nestedDate = new Date(nestedEvent.startEvent);

      if (this.scale === 'month') {
        const dayOfMonth = nestedDate.getDate();
        const daysInMonth = new Date(period.getFullYear(), period.getMonth() + 1, 0).getDate();
        const positionInMonthPx = (dayOfMonth / daysInMonth) * 60; // baseWidth pour month
        return positionInMonthPx - 6.5;
      } else if (this.scale === 'week') {
        const startOfCurrentWeek = new Date(period);
        startOfCurrentWeek.setDate(period.getDate() - period.getDay() + 1);
        const daysFromWeekStart = Math.floor((nestedDate - startOfCurrentWeek) / (1000 * 60 * 60 * 24));
        const positionInWeekPx = (daysFromWeekStart / 7) * 100;
        return positionInWeekPx + 6.5;
      } else if (this.scale === 'day') {
        return 6.5;
      }
      return 0;
    }
  },
};
</script>

<style scoped>
@import '../../assets/css/timeline.css';

.backwhite {
  background-color: #FFFFFF;
}

.tr-title {
  text-align: left;
  font-weight: 500;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
}

svg[aria-label="chevron right"],
svg[aria-label="chevron down"] {
  color: #FFFFFF;
}

.legend-container {
  display: flex;
  justify-content: start;
  gap: 4em;
  margin-bottom: 1rem;
}

.legend-item {
  display: flex;
  align-items: center;
}

.legend-color {
  width: 28px;
  height: 18px;
  border-radius: 2px;
  margin-right: 1rem;
}

.legende-mail {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: var(--main-red);
  border: 2px solid var(--main-color);
  margin-right: 1rem;
  z-index: 1;
}

.legend-text {
  font-size: 14px;
}

.explication {
  color: var(--tertiary-text-color);
  font-size: 14px;
  font-family: "Montserrat-Regular", "Arial", sans-serif;
  display: flex;
  justify-content: start;
  align-items: center;
}

svg[aria-label="info circle"] {
  width: 1.25em;
  height: 1.25em;
  margin-right: 0.5em;
}

.toggle-sub-events-button {
  cursor: pointer;
  margin-left: 5px;
  transition: transform 0.3s;
}

.toggle-sub-events-button.rotated {
  transform: rotate(90deg);
}

.scale-selector {
  margin-bottom: 20px;
  margin-top: 20px;
}

input[type="color"] {
  width: 0!important;
  height: 0!important;
  padding: 0!important;
  border: none;
  cursor: pointer;
}
#color_front{
  border-radius: 50%;
  width: 15px;
  height: 15px;
  padding: 0;
  display:flex;
}
</style>



// WEBPACK FOOTER //
// src/views/operationPlanning/EventItems.vue